import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { createHead } from '@vueuse/head';
import { Amplify  } from 'aws-amplify';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue';
import router from './router';

import * as Sentry from "@sentry/vue";

import './assets/main.css';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_AWS_USERPOOLID,
      userPoolClientId: import.meta.env.VITE_AUTH_CLIENTID,

      loginWith: {
        email: true,
      },
    },
  },
});

const head = createHead({
  titleTemplate: '%s | RailOps'
});

const app = createApp(App);

if (import.meta.env.VITE_SENTRY_ENABLED && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.feedbackIntegration({
        // Additional SDK configuration goes in here, for example:
        colorScheme: "system",
        isNameRequired: true,
        isEmailRequired: true,

        triggerLabel: "Submit feedback",
        formTitle: "Submit Feedback",
        submitButtonLabel: "Submit",
        messagePlaceholder: "Please describe your issue or share your feedback.",
      }),
    ],
  });
}

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate)

app.use(pinia);
app.use(router);
app.use(head);

app.mount('#app');
